export const actions = {
  SHOW_OUTFIT: "SHOW_OUTFIT",
};

export const showOutfit = (isVisible, screenshot) => ({
  type: actions.SHOW_OUTFIT,
  isVisible,
  screenshot,
});
